import { User } from "../../types/user";
import { get, post, put, del } from "./httpClient";

export async function getUsers() {
  return get<User[]>("/users", { cacheResponse: 10 }); // 10 minute cache
}

export async function createUser(
  userData: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    mobile: string;
    role: "admin" | "user";
    status: "active" | "inactive";
    site: string;
  },
) {
  return post<User>("/users", userData, { cacheResponse: false });
}

export async function updateUser(
  userId: string,
  userData: Partial<User>,
) {
  return put<User>(`/users/${userId}`, userData, { cacheResponse: false });
}

export async function updateAvailabilityException(
  userId: string,
  data: {
    date: string;
    part: "am" | "pm";
    value: boolean;
  },
) {
  return put(`/users/${userId}/exceptions`, data, { cacheResponse: false });
}

export async function deleteUser(userId: string) {
  return del(`/users/${userId}`, { cacheResponse: false });
}
